module.exports = __webpack_public_path__ + "img/infraestructura-ferroviaria.f55c14d9.webp";